import * as React from "react";
import { Hr } from "@grandvisionhq/elements";
import { ProductDetailUspsContainer } from "../../../../../../modules/ProductDetailUsps/ProductDetailUspsContainer.js";
/* empty css                              */
const ProductDetailUspsSection = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Hr, { className: "product-detail-usps__divider" }), /* @__PURE__ */ React.createElement(ProductDetailUspsContainer, { className: "product-detail-usps__container" }));
export {
  ProductDetailUspsSection
};
//# sourceMappingURL=ProductDetailUspsSection.js.map
